import type { Options } from "ky";

import { postJson } from "#app/lib/fetchClient";

import { GATEWAY_PATHS } from "../api-utils";

type PostRegistrationVerifyIdentityParams = {
  body: {
    zip: string;
    ssn: string;
    dateOfBirth: string;
    email: string;
    phone: string;
    firstName: string;
  };
};

export async function postRegistrationVerifyIdentity(
  params: PostRegistrationVerifyIdentityParams & Pick<Options, "signal">,
): Promise<void> {
  // Call endpoint
  await postJson(
    `${GATEWAY_PATHS.externalBolRegistrationService}/Registration/VerifyIdentity`,
    { json: params.body, signal: params.signal },
    true,
  );
}
